import React, { useContext, useEffect } from 'react'
import Stepper from '../StepForm/Stepper'
import { globalContext } from '../Context/GlobalContext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const RegistroUsuario = () => {

  const { colorTheme } = useContext(globalContext)
  const navigate = useNavigate();
  const country = process.env.REACT_APP_COUNTRY;

  // Bloquear acceso a /registroUsuario para USA
  useEffect(() => {
    if (country === "USA") {
      Swal.fire({
        icon: 'info',
        title: 'Registration Not Available',
        text: 'The registration functionality is currently not available for USA. Please contact us for more information.',
        confirmButtonText: 'Go to Home',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(() => {
        navigate('/', { replace: true });
      });
    }
  }, [country, navigate]);

  return (
    <>
      <div className={`w-screen h-screen flex flex-col items-center justify-content-start py-4 bg-${colorTheme}`}>

        <Stepper />

      </div>


    </>
  );
}

export default RegistroUsuario
